import { Grid, SvgIcon } from '@material-ui/core';
import React, { useRef, useState } from 'react'
import { ButtonHLPure, HeaderHLPure, TooltipHLPure } from '../../../pures';
import { useTranslation } from 'react-i18next';

function ChangePasswordForm(props) {
  const {
    user,
    moveStep,
    onSubmitStep
  } = props;

  const { t } = useTranslation()
  const { t: tCommon } = useTranslation('common')
  const [passwordIcon, setPasswordIcon] = useState(['login-input-show-password-icon-desactive', 'login-input-show-password-icon-desactive'])
  const passwordRef = useRef(null)
  const confirmPasswordRef = useRef(null)

  const onHandleShowPassword = (selector, key) => {
    let auxPasswordIcon = [...passwordIcon]
    let inputPassword = document.querySelector(selector);

    if (passwordIcon[key] === "login-input-show-password-icon-desactive" && inputPassword.type === "password") {
      inputPassword.type = "text";

      auxPasswordIcon[key] = "login-input-show-password-icon-active"
      setPasswordIcon(auxPasswordIcon)
    } else {
      inputPassword.type = "password";

      auxPasswordIcon[key] = "login-input-show-password-icon-desactive"
      setPasswordIcon(auxPasswordIcon)
    }
  };

  return (
    <Grid container className='personalDataForm' spacing={3}>
      <Grid item xs={12}>
        <HeaderHLPure title={tCommon("changePasswordTitle")} headingNumber={2} />
      </Grid>

      <Grid item xs={12}>
        <div className='loginForm-label-tooltip'>
          <label htmlFor="password" className="loginForm-input-label">{t("loginView.placeholderPassword")}</label>
          <TooltipHLPure
            titleTooltip={t("loginView.passwordTooltipTitle")}
            freeContent={(
              <ul className='loginForm-label-tooltip-content'>
                <li>{t("loginView.passwordTooltipDesc1")}</li>
                <li>{t("loginView.passwordTooltipDesc2")}</li>
                <li>{t("loginView.passwordTooltipDesc3")}</li>
                <li>{t("loginView.passwordTooltipDesc4")}</li>
              </ul>
            )}
            informationIcon
          />
        </div>
        <div className='loginForm-input-wrapper'>
          <input
            type="password"
            className="loginForm-input-field loginForm-input-password"
            id="password"
            ref={passwordRef}
          />

          {/* EYE ICON */}
          <button className='loginForm-showPasswordBtn' onClick={() => {
            console.log('testing button')
            onHandleShowPassword('#password', 0)
          }}
          >
            <SvgIcon
              className={`loginForm-input-icon ${passwordIcon[0]}`}
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
            </SvgIcon>
          </button>
        </div>
      </Grid>

      <Grid item xs={12}>
        <label htmlFor="password" className="loginForm-input-label">{tCommon('confirmPassword')}</label>
        <div className='loginForm-input-wrapper'>
          <input
            type="password"
            className="loginForm-input-field loginForm-input-password"
            id="confirmPassword"
            ref={confirmPasswordRef}
          />

          {/* EYE ICON */}
          <button className='loginForm-showPasswordBtn' onClick={() => { onHandleShowPassword('#confirmPassword', 1) }}>
            <SvgIcon
              className={`loginForm-input-icon ${passwordIcon[1]}`}
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
            </SvgIcon>
          </button>
        </div>
      </Grid>

      <Grid item xs={12} className='onboardingView-actions'>
        <ButtonHLPure type="submit" colorScheme="primary" outlined nameBtn={tCommon("continue")} onClick={() => {
          onSubmitStep({ password: passwordRef.current.value, confirmPassword: confirmPasswordRef.current.value })
        }} />
      </Grid>
    </Grid>
  )
}

export default ChangePasswordForm